import { ThemeProvider, CssBaseline } from '@mui/material';
import { RouterProvider } from 'react-router/dom';
import { router } from './router';
import { retroTheme } from './theme';

function App() {
  return (
    <ThemeProvider theme={retroTheme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
